var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93958 0 0 6.93959 0 15.5C0 24.0604 6.93958 31 15.5 31ZM6.31695 11.632C6.31695 8.64475 8.71912 6.21324 11.6723 6.21324H19.3248C22.2787 6.21324 24.683 8.6425 24.683 11.6289V19.3677C24.683 22.3549 22.2808 24.7864 19.3277 24.7864H11.6752C8.72134 24.7864 6.31695 22.3572 6.31695 19.3708V11.632ZM21.622 10.0827C21.622 9.65547 21.2791 9.30877 20.8567 9.30877C20.4343 9.30877 20.0915 9.65547 20.0915 10.0827C20.0915 10.5098 20.4343 10.8565 20.8567 10.8565C21.2791 10.8565 21.622 10.5098 21.622 10.0827ZM20.0915 15.4998C20.0915 12.939 18.0322 10.8565 15.5 10.8565C12.9678 10.8565 10.9084 12.939 10.9084 15.4998C10.9084 18.0607 12.9678 20.1431 15.5 20.1431C18.0322 20.1431 20.0915 18.0607 20.0915 15.4998ZM13.3355 13.311C13.9096 12.7305 14.6882 12.4043 15.5 12.4043C16.3118 12.4043 17.0904 12.7305 17.6644 13.311C18.2385 13.8915 18.561 14.6789 18.561 15.4998C18.561 16.3208 18.2385 17.1082 17.6644 17.6887C17.0904 18.2692 16.3118 18.5954 15.5 18.5954C14.6882 18.5954 13.9096 18.2692 13.3355 17.6887C12.7615 17.1082 12.4389 16.3208 12.4389 15.4998C12.4389 14.6789 12.7615 13.8915 13.3355 13.311Z",
    fill: "#4AFEBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.87eee1181557749ea27c141c731b4118.svg";
export { ForwardRef as ReactComponent };